module.exports = __webpack_public_path__ + "static/LogoBaseline2-ea4d61586b4e4ad4469a3de67888640f.svg";